<div class="contact-bar">
  <div class="contact-bar__content">
    <h2 class="contact-bar__title {{ titleSize ? 'contact-bar__title--size-' + titleSize : '' }}">{{ title ?? ('contactBar.title' | translate) }}</h2>
    <ng-content></ng-content>
  </div>
  <div class="contact-bar__address">
    <div class="contact-bar__address-item">
      <app-small-title>{{ 'contactBar.address' | translate }}</app-small-title>
      <span>
        {{ 'globals.contactData.street' | translate }}<br />
        <app-color-text [size]="'medium'" [color]="'default'">{{ 'globals.contactData.city' | translate }}</app-color-text>
      </span>
    </div>
    <div class="contact-bar__address-item">
      <app-small-title>{{ 'contactBar.openingHours' | translate }}</app-small-title>
      <span>
        {{ 'globals.contactData.openingHours' | translate }}<br />
        {{ 'globals.contactData.openingHoursWeekend' | translate }}
      </span>
    </div>
  </div>
  <div class="contact-bar__buttons">
    @if (buttons === 'all') {
      <!--<app-button [href]="'https://www.google.com/'" [size-sm]="'small'" [color]="'light'" [outlined]="true" [outline-width]="'thin'" [target]="'_blank'">{{ 'contactBar.3dTour' | translate }}</app-button>-->
    }
    <app-map-button [square]="buttons === 'all'" [href]="'https://www.google.com/maps/place/Mototechna/@50.1094793,14.5419681,18z/data=!4m14!1m7!3m6!1s0x470bed430a8f63bb:0x85f18bdb37da0252!2sMototechna!8m2!3d50.1094779!4d14.5430545!16s%2Fg%2F11ww7zn1s4!3m5!1s0x470bed430a8f63bb:0x85f18bdb37da0252!8m2!3d50.1094779!4d14.5430545!16s%2Fg%2F11ww7zn1s4?entry=ttu&g_ep=EgoyMDI1MDQyMy4wIKXMDSoASAFQAw%3D%3D'">
      <app-icon [icon]="'map'" [width]="24">{{ 'contactBar.showOnMap' | translate }}</app-icon>
      @if (buttons === 'map') {
        {{ 'contactBar.showOnMap' | translate }}
      }
    </app-map-button>
    @if (buttons === 'all') {
      <app-button [route]="this.globals.routes()['aboutCompany'].url" [size-sm]="'small'" [color]="'light'">{{ 'contactBar.showMore' | translate }}</app-button>
    }
  </div>
</div>
